document.addEventListener('DOMContentLoaded', () => {
    function getFocusableElements(container) {
        const focusableSelectors = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ].join(', ');
        return Array.from(container.querySelectorAll(focusableSelectors));
    }

    function toggleFocusableElements(content, isOpen) {
        const focusableElements = getFocusableElements(content);

        focusableElements.forEach((element) => {
            if (isOpen) {
                if (element.dataset.originalTabindex !== undefined) {
                    const originalTabindex = element.dataset.originalTabindex;
                    if (originalTabindex === 'null' || originalTabindex === '') {
                        element.removeAttribute('tabindex');
                    } else {
                        element.setAttribute('tabindex', originalTabindex);
                    }
                    delete element.dataset.originalTabindex;
                }
                return;
            }
            const currentTabindex = element.getAttribute('tabindex');
            element.dataset.originalTabindex = currentTabindex || 'null';
            element.setAttribute('tabindex', '-1');
        });
    }

    const expandAccordionContent = (content) => {
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.querySelectorAll('img').forEach((img) => {
            if (!img.complete) {
                img.addEventListener('load', () => {
                    if (content.getAttribute('aria-hidden') === 'false') {
                        content.style.maxHeight = `${content.scrollHeight}px`;
                    }
                }, { once: true });
            }
        });
    };

    function initAccordions() {
        const accordions = document.querySelectorAll('[data-accordion]');

        accordions.forEach((accordion) => {
            const trigger = accordion.querySelector('[data-accordion-trigger]');
            const content = accordion.querySelector('[data-accordion-content]');
            const iconElement = accordion.querySelector('[data-accordion-icon]');
            const iconType = iconElement?.dataset.accordionIconType || 'plus-minus';
            const iconPlus = accordion.querySelector('[data-accordion-icon-plus]');
            const iconMinus = accordion.querySelector('[data-accordion-icon-minus]');

            if (!trigger || !content) return;

            if (trigger.dataset.accordionInitialized === 'true') return;
            trigger.dataset.accordionInitialized = 'true';

            const isOpen = trigger.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
                expandAccordionContent(content);
                if (iconType === 'chevron' && iconElement) {
                    iconElement.classList.add('rotate-180');
                } else {
                    if (iconPlus) iconPlus.classList.add('hidden');
                    if (iconMinus) iconMinus.classList.remove('hidden');
                }
            } else {
                content.style.maxHeight = '0px';
                if (iconType === 'chevron' && iconElement) {
                    iconElement.classList.remove('rotate-180');
                } else {
                    if (iconPlus) iconPlus.classList.remove('hidden');
                    if (iconMinus) iconMinus.classList.add('hidden');
                }
                toggleFocusableElements(content, false);
            }

            trigger.addEventListener('click', () => {
                const isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
                const newState = !isCurrentlyOpen;

                const groupContainer = accordion.closest('[data-accordion-group]');
                const singleOpen = groupContainer && groupContainer.getAttribute('data-single-open') === 'true';

                if (singleOpen && newState && groupContainer) {
                    const siblingAccordions = groupContainer.querySelectorAll('[data-accordion]');

                    siblingAccordions.forEach((siblingAccordion) => {
                        if (siblingAccordion === accordion) return;

                        const siblingTrigger = siblingAccordion.querySelector('[data-accordion-trigger]');
                        const siblingContent = siblingAccordion.querySelector('[data-accordion-content]');
                        const siblingIconElement = siblingAccordion.querySelector('[data-accordion-icon]');
                        const siblingIconType = siblingIconElement?.dataset.accordionIconType || 'plus-minus';
                        const siblingIconPlus = siblingAccordion.querySelector('[data-accordion-icon-plus]');
                        const siblingIconMinus = siblingAccordion.querySelector('[data-accordion-icon-minus]');

                        if (siblingTrigger && siblingContent) {
                            const isSiblingOpen = siblingTrigger.getAttribute('aria-expanded') === 'true';
                            if (isSiblingOpen) {
                                siblingTrigger.setAttribute('aria-expanded', 'false');
                                siblingContent.setAttribute('aria-hidden', 'true');
                                siblingContent.style.maxHeight = '0px';
                                toggleFocusableElements(siblingContent, false);
                                if (siblingIconType === 'chevron' && siblingIconElement) {
                                    siblingIconElement.classList.remove('rotate-180');
                                } else {
                                    if (siblingIconPlus) siblingIconPlus.classList.remove('hidden');
                                    if (siblingIconMinus) siblingIconMinus.classList.add('hidden');
                                }
                            }
                        }
                    });
                }

                trigger.setAttribute('aria-expanded', newState);
                content.setAttribute('aria-hidden', !newState);

                toggleFocusableElements(content, newState);

                if (newState) {
                    expandAccordionContent(content);
                    if (iconType === 'chevron' && iconElement) {
                        iconElement.classList.add('rotate-180');
                    } else {
                        if (iconPlus) iconPlus.classList.add('hidden');
                        if (iconMinus) iconMinus.classList.remove('hidden');
                    }
                    return;
                }
                content.style.maxHeight = '0px';
                if (iconType === 'chevron' && iconElement) {
                    iconElement.classList.remove('rotate-180');
                } else {
                    if (iconPlus) iconPlus.classList.remove('hidden');
                    if (iconMinus) iconMinus.classList.add('hidden');
                }
            });
        });
    }

    initAccordions();

    window.initAccordions = initAccordions;

    const observer = new MutationObserver(() => {
        initAccordions();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});